<template>
	<div class="content-edit-listing">
		<b-container fluid="xl">
			<b-row align-h="between" class="listing-detail-page-header">
				<b-col md="12" lg="6">
					<div class="add-listing-header">
						<div class="title">{{ $t('post') }}</div>
					</div>
				</b-col>
				<b-col md="12" lg="6" class="pd-lr-7 w340" align-self="center">
					<div class="wrap-btn text-right">
						<UserMenuDropdown v-if="$root.isAuthenticated" :userName="userName" />
						<b-button
							v-else
							id="openKhaosodLogin"
							@click="openKhaosodLogin"
							class="btn-login btn-item"
						>
							<IconLogin />
							{{ $t('login') }}
						</b-button>
					</div>
				</b-col>
			</b-row>
			<div class="steper-add-listing">
				<div class="divider"></div>
				<div class="stepper-circle">
					<div class="circle-title" v-bind:class="{ selected: firstStep }">
						<div class="circle">
							<PencilIcon />
						</div>
						<span class="title">{{ $t('addListing.details.details') }}</span>
					</div>
					<!-- <div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<MagnifyIcon />
						</div>
						<span class="title">{{ $t('addListing.preview.preview') }}</span>
					</div> -->
					<div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<CheckIcon />
						</div>
						<span class="title">{{ $t('addListing.neat.neat') }}</span>
					</div>
				</div>
			</div>
			<div class="add-listing-form">
				<div class="trasnlation-div d-flex flex-row justify-content-start align-items-start" v-if="supportedLanguages.length>1&&projectConfig.affiliate != 'ThaiRath'&&false">
					<template v-for="(item, key) in supportedLanguages">
						<div :key="key" class="lang-div d-flex flex-row justify-content-center align-items-center p-2" :class="selectedLangugae==item?'active-lang':''"
							@click="changeLanguageTab(item)">
							<span v-if="selectedLangugae==item" >
									{{$t('addListing.details.selectLanguage'+item)}}
							</span>
							<span v-else>
									{{$t('addListing.details.selectLanguage'+item)}}
							</span>
							
						</div>
					</template>
					
				</div>

				<!-- FIRST STEP -->
				<b-form class="form-search" v-if="firstStep">
					<!-- Translate call-to-action -->
					<span v-if="false">
					<template v-for="(item, key) in supportedLanguages">
						
						<b-row :key="'B'+key" class="translate-row mt-3 mb-4" align-v="center" v-if="key!=0&&item==selectedLangugae">
							
								<b-col cols="8">
									<p class="mb-0 mt-3">
										{{$t('addListing.details.translateNote1',selectedLangugae)}}
									</p>
									<p class="mt-0">
										{{$t('addListing.details.translateNote2',selectedLangugae)}}
									</p>
									<p class="small">
										{{$t('addListing.details.translateNote3',selectedLangugae)}}
									</p>
								</b-col>
								<b-col class="text-center">
									<b-button class="translate-btn" @click="trasnlateToOtherLanguage()">
										{{$t('addListing.details.translateTo',selectedLangugae)}} {{$t('addListing.details.'+selectedLangugae)}}
									</b-button>
								</b-col>
							
						</b-row>
					</template>
					</span>
					<div class="form-group row">
						<label class="col-3 required-label">{{
							$t('addListing.details.selectProductCategory', selectedLangugae)
						}}</label>
						<b-col cols="9">
							<b-row class="input-div">
								<!-- Main category -->
								<b-col :cols="childCategories.childSubCategory.listing_category_children.length?4:6" class="pl-15">
									<b-button
										class="main-category-button"
										v-b-modal.modal-center
									>
										{{ $t(listing.mainCategory.name) }}
										<ChevronDownIcon />
									</b-button>
									<b-modal
										id="modal-center"
										centered
										hide-header
										hide-footer
										body-class="main-category"
									>
										<h4>
											{{ $t('addListing.details.selectProductCategory', selectedLangugae) }}
										</h4>
										<div class="select-categories">
											<div
												class="category-div"
												@click="
													hideModal(
														'modal-center',
														key + 1,
														value.id,
														value.name
													)
												"
												v-for="(value, key) in categoriesOptions"
												v-bind:key="key"
											>
												<div v-html="value.url_icon2" class="icon-div"></div>
												<h5>{{ $t(value.name) }}</h5>
											</div>
										</div>
									</b-modal>
								</b-col>
								<!-- Sub category -->
								<b-col :cols="childCategories.childSubCategory.listing_category_children.length?4:6" class="pr-15" v-if="childCategories.listing_category_children.length">
									<b-dropdown no-flip
										:class="{
											'input-error': validateErrors
												? validateErrors.idSubListing
												: false
										}"
										class="menu-dropdown"
									>
										<template v-slot:button-content>
											<span>
												{{
													listing.subCategory
														? $t(listing.subCategory.name)
														: $t('addListing.details.selectSubCategory', selectedLangugae)
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											v-for="category in childCategories.listing_category_children"
											:key="category.id"
											@click="listing.subCategory = category"
											>{{ $t(category.name) }}</b-dropdown-item>
									</b-dropdown>
								</b-col>
								<b-col :cols="childCategories.childSubCategory.listing_category_children.length?4:6" class="pr-15" 
									v-if="childCategories.childSubCategory.listing_category_children.length">
									<b-dropdown no-flip
										:class="{
											'input-error': validateErrors
												? validateErrors.idsubSubListing
												: false
										}"
										class="menu-dropdown"
									>
										<template v-slot:button-content>
											<span>
												{{
													listing.subSubCategory && listing.subSubCategory.name
														? $t(listing.subSubCategory.name)
														: $t('addListing.details.selectSubCategory', selectedLangugae)
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											v-for="category in childCategories.childSubCategory.listing_category_children"
											:key="category.id"
											@click="listing.subSubCategory = category"
											>{{ $t(category.name) }}</b-dropdown-item
										>
									</b-dropdown>
								</b-col>
							</b-row>
						</b-col>
					</div>
					<!-- Product name -->
					<div class="form-group row">
						<label class="col-3 required-label">{{
							$t(childCategories.field_name_title)
						}}</label>
						<div class="input-div col-9">
							<b-form-input
								:placeholder="$t(childCategories.field_name_title)"
								class="input-search form-control"
								:class="{
									'input-error': validateErrors ? validateErrors.title : false
								}"
								v-model="listing.title"
							></b-form-input>
						</div>
					</div>
					<!-- Attributes -->
					<template
						v-for="(item, key) in childCategories.category_attribute_details"
					>
					
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Radio button'
							"
						>
							<div class="input-div-for-rent-sale col-12">
								<label class="col-3 required-label">{{
									$t(item.listing_attribute.name)
								}}</label>
								<b-form-radio-group
									class="sale-rent-radio"
									:name="`radio-sub-component-${key + 1}`"
									v-for="(value, k) in item.listing_attribute
										.listing_pre_values"
									:key="k"
									@change="
										changeRadioValue($event, `radioValue_${item.attr_id}`)
									"
									v-model="
										listing.listingAttr.data[`radioValue_${item.attr_id}`]
									"
								>
									<b-form-radio :value="value.id">{{
										$t(value.value)
									}}</b-form-radio>
								</b-form-radio-group>
								<span v-if="item.id==23||item.id==135" style="position: absolute;right: 209px;">
								<b-icon-question-circle variant="primary" id="price-info" style="color:var(--projectPrimaryColor) !important;"/>
								<b-tooltip
									custom-class="website-tool-tips"
									placement="righttop"
									target="price-info"
								>
									{{$t('addListing.details.rentOrSaleNote', selectedLangugae)}}
								</b-tooltip>
								</span>
							</div>
						</div>
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type == 'Textbox'
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							<b-col cols="9">
								<div class="input-div row">
									<b-col cols="6" class="pl-15">
										<b-form-input
											:placeholder="$t(item.listing_attribute.placeholder)"
											class="input-search form-control"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:min="item.listing_attribute.min"
											:max="item.listing_attribute.max"
											:disabled="item.listing_attribute.disabled"
										></b-form-input>
									</b-col>
									<b-col
										v-if="
											item.listing_attribute.listing_attributes_children.length
										"
										cols="6"
										class="pr-15"
									>
										<div
											v-for="(value, key) in item.listing_attribute
												.listing_attributes_children"
											:key="key"
										>
											<div
												v-if="
													value.listing_attributes_type.type == 'Select option'
												"
											>
												<b-dropdown no-flip
													class="menu-dropdown"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `selectValue_${value.id}`
															)
													}"
												>
													<template v-slot:button-content>
														<span>
															{{
																dropdownChooseValue[
																	`selectValue_${value.id}`
																]?$t(dropdownChooseValue[`selectValue_${value.id}`]):$t(value.placeholder)
															}}
															<ChevronDownIcon />
														</span>
													</template>
													<b-dropdown-item
														v-for="(val, k) in value.listing_pre_values"
														:key="k"
														@click="
															listing.listingAttr.data[
																`selectValue_${value.id}`
															] = val.id;
															dropdownChooseValue[
																`selectValue_${value.id}`
															] = val.value;
														"
														>{{ $t(val.value) }}</b-dropdown-item
													>
												</b-dropdown>
											</div>
											<div
												v-else-if="
													value.listing_attributes_type.type == 'Textbox'
												"
											>
												<b-form-input
													:placeholder="$t(value.placeholder)"
													class="input-search form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:min="item.listing_attribute.min"
													:max="item.listing_attribute.max"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
												></b-form-input>
											</div>
											<div
												v-else-if="
													value.listing_attributes_type.type == 'Checkbox'
												"
											>
											
											<b-form-checkbox  :value="true" :unchecked-value="false" 
											@input="item.listing_attribute.disabled=listing.listingAttr.data[`checkboxValue_${value.id}`]"
												v-model="listing.listingAttr.data[`checkboxValue_${value.id}`]">
												{{$t(value.placeholder)}}</b-form-checkbox>
												
											</div>
										</div>
									</b-col>
								</div>
							</b-col>
						</div>
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Select option'
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							<div class="single-select input-div col-9">
								<b-dropdown no-flip
									class="menu-dropdown"
									:class="{
										'input-error':
											isValidate &&
											!validateInputDynamic.some(
												temp => temp === `selectValue_${item.attr_id}`
											),
										'full-width': listing.mainCategory.idCategory == 4
									}"
								>
									<template v-slot:button-content>
										<span>
											{{ dropdownChooseValue[`selectValue_${item.attr_id}`]?
											$t(dropdownChooseValue[`selectValue_${item.attr_id}`]):
											$t(item.placeholder) }}
											<ChevronDownIcon />
										</span>
									</template>
									<b-dropdown-item
										v-for="(value, k) in item.listing_attribute
											.listing_pre_values"
										:key="k"
										@click="
											listing.listingAttr.data[`selectValue_${item.attr_id}`] =
												value.id;
											dropdownChooseValue[`selectValue_${item.attr_id}`] =
												value.value;
										"
										>{{ $t(value.value) }}</b-dropdown-item
									>
								</b-dropdown>
							</div>
						</div>
						<div
							class="form-group row"
							:class="{'align-items-start':item.attr_id==5}"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Number' && !listing.listingAttr.data.radioValue_18
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							
							<b-col cols="9">
								
								<div class="input-div row">
									<label class="col-6 text-left" v-if="item.attr_id==5">{{
										$t(item.listing_attribute.name)
										}}
									</label>
									<label class="col-6 text-left" v-if="item.attr_id==5">{{
												$t(item.listing_attribute
												.listing_attributes_children[0].placeholder)
									}}
									</label>
									<b-col cols="6" class="pl-15">
										<masked-input
											type="text"
											class="input-search  form-control"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											:mask="numberAmountMask()"
											:placeholder="$t(item.listing_attribute.placeholder)"
											:disabled="item.listing_attribute.disabled"
										></masked-input>
									</b-col>

									<b-col
										v-if="
											item.listing_attribute.listing_attributes_children.length
										"
										cols="6"
										class="pr-15 justify-content-center align-items-center align-self-center"
									>
									
										<div
											v-for="(value, key) in item.listing_attribute
												.listing_attributes_children"
											:key="key"
										>
										<div
												v-if="
													value.listing_attributes_type.type == 'Select option'
												"
											>
												<b-dropdown no-flip
													class="menu-dropdown"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `selectValue_${value.id}`
															)
													}"
												>
												<template v-slot:button-content>
														<span>
															{{
																dropdownChooseValue[`selectValue_${value.id}`]?
																$t(dropdownChooseValue[`selectValue_${value.id}`]):
																$t(value.placeholder)
															}}
															<ChevronDownIcon />
														</span>
													</template>
													<b-dropdown-item
														v-for="(val, k) in value.listing_pre_values"
														:key="k"
														@click="
															listing.listingAttr.data[
																`selectValue_${value.id}`
															] = val.id;
															dropdownChooseValue[`selectValue_${value.id}`] = val.value;
														"
														>{{ $t(val.value)}}</b-dropdown-item
													>
												</b-dropdown>
												
												
											</div>
											<div
												v-if="value.listing_attributes_type.type == 'Textbox'"
											>
												<b-form-input
													:placeholder="$t(value.placeholder)"
													class="input-search form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:min="item.listing_attribute.min"
													:max="item.listing_attribute.max"
												></b-form-input>
											</div>
											<div
												v-if="value.listing_attributes_type.type == 'Number'"
											>
											
												<masked-input
													type="text"
													class="input-search price-input form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:mask="numberAmountMask()"
													:placeholder="$t(value.placeholder)"
												></masked-input>
											</div>
											<div	
											>
												<b-form-checkbox 
													v-if="
														value.listing_attributes_type.type == 'Checkbox'
													"
													:key="listing.listingAttr.data[`checkboxValue_${value.id}`]"
        											:value="true"
      												:unchecked-value="false"
													@input="item.listing_attribute.disabled = listing.listingAttr.data[`checkboxValue_${value.id}`];$forceUpdate()"
													v-model="listing.listingAttr.data[`checkboxValue_${value.id}`]">
													{{$t(value.placeholder)}}</b-form-checkbox>
												
											</div>
										</div>
									</b-col>
								</div>
							</b-col>
						</div>

						
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Number' && listing.listingAttr.data.radioValue_18 == 56
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							<b-col cols="9">
								<div class="input-div row">
									<b-col cols="6" class="pl-15">
										<masked-input
											type="text"
											class="input-search price-input form-control"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											:mask="numberAmountMask()"
											:placeholder="$t(item.listing_attribute.placeholder)"
											:disabled="item.listing_attribute.disabled"
										></masked-input>
									</b-col>

									<b-col
										v-if="
											item.listing_attribute.listing_attributes_children.length
										"
										cols="6"
										class="pr-15"
									>
										<div
											v-for="(value, key) in item.listing_attribute
												.listing_attributes_children"
											:key="key"
										>
											<div
												v-if="value.listing_attributes_type.type == 'Textbox'"
											>
												<b-form-input
													:placeholder="$t(value.placeholder)"
													class="input-search form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:min="item.listing_attribute.min"
													:max="item.listing_attribute.max"
												></b-form-input>
											</div>
											<div
												v-if="value.listing_attributes_type.type == 'Number'"
											>
												<masked-input
													type="text"
													class="input-search price-input form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:mask="numberAmountMask()"
													:placeholder="$t(value.placeholder)"
												></masked-input>
											</div>
											<div	v-if="
													value.listing_attributes_type.type == 'Checkbox'
												"
											>
											
											<b-form-checkbox 
												:key="listing.listingAttr.data[`checkboxValue_${value.id}`]"
        											:value="true"
      												:unchecked-value="false"
												@input="item.listing_attribute.disabled=listing.listingAttr.data[`checkboxValue_${value.id}`];$forceUpdate()"
												v-model="listing.listingAttr.data[`checkboxValue_${value.id}`]">
												{{$t(value.placeholder)}}</b-form-checkbox>
												
											</div>
										</div>
									</b-col>
								</div>
							</b-col>
						</div>
					</template>
					<!-- Price -->
					
					<div class="form-group row" >
						<label class="col-3 required-label">{{
							$t('addListing.details.price', selectedLangugae)
						}}</label>
						<div
							class="price-input-div"
							:class="{
								'input-error': validateErrors ? validateErrors.price : false
							}"
						>
							<masked-input
								type="text"
								class="input-search price-input"
								v-model="listing.price"
								:mask="numberAmountMask()"
								:placeholder="$t('addListing.details.price', selectedLangugae)"
							></masked-input>
							<b-icon-question-circle variant="primary" id="price-info" style="color:var(--projectPrimaryColor) !important;"/>
							<b-tooltip
								custom-class="website-tool-tips"
								placement="righttop"
								target="price-info"
							>
								{{$t('addListing.details.priceNote', selectedLangugae)}}
							</b-tooltip>
						</div>
					</div>
					<!-- Image -->
					<div class="form-group make-label-start row">
						<label class="col-3 required-label">{{
							$t('addListing.details.productImages',selectedLangugae)
						}}</label>
						<div class="input-div col-9">
							<Fileuploader
								name="files"
								:maxFiles="'10'"
								:class="{
									'input-error': validateErrors
										? validateErrors.imageError
										: false
								}"
								:accept="'jpg, png, jpeg'"
								:hideFileUploader="hideFileUploader"
								:multiple="true"
								@childToParent="getFile"
								:fileUploaded="arrImageUploaded"
								:theme="'thumbnails'"
								:changeInput="' '"
							/>
							<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Recommend picture size 1200x675 pixel')}}</p>
						</div>
					</div>
					<!-- Description -->
					<div class="form-group description make-label-start row">
						<label class="col-3 required-label">{{
							$t(childCategories.field_name_description)
						}}</label>
						<div class="input-div col-9">
							<b-form-textarea
								:placeholder="$t(childCategories.field_name_description)"
								class="input-search"
								:class="{
									'input-error': validateErrors
										? validateErrors.description
										: false
								}"
								v-model="listing.description"
							></b-form-textarea>
						</div>
					</div>
					<!-- Keywords -->
					<div class="form-group row keywords" >
						<label class="col-3">{{ $t('addListing.details.keywords',selectedLangugae) }}</label>
						<div class="input-div col-9">
							<b-form-tags
								input-id="tags-validation"
								:input-attrs="{
									'aria-describedby': 'tags-validation-help'
								}"
								separator=" ,;"
								remove-on-delete
								:tag-validator="tagValidator"
								v-model="listing.keywords"
								class="mb-2"
								tag-pills
								size="md"
								:placeholder="$t('addListing.details.keywordsPlaceholder',selectedLangugae)"
								isDuplicate="false"
							></b-form-tags>
							<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Please fill keywords relate with your listing for customer searching and found you listing')}}</p>
						
						</div>
					</div>
					<!-- google maps -->
					<div class="form-group row">
						<label class="col-3 required-label">{{$t('addListing.details.Address',selectedLangugae)}}</label>
						<b-col cols="7" class="pr-0">
							<div class="input-div row no-gutters">
								<b-form-input
									:placeholder="$t('addListing.details.Address',selectedLangugae)"
									class="input-search"
									:class="{
										'input-error': validateErrors
											? validateErrors.address
											: false
									}"
									v-model="loclationAddress"
									disabled
									style="border-bottom-right-radius: 0; border-top-right-radius: 0;"
								></b-form-input>
							</div>
						</b-col>
						<b-col cols="2" class="pl-0">
							<div class="input-div row no-gutters">
								<div class="show-google-maps" v-b-modal.showgooglemap-model>{{$t('addListing.details.showOnMap',selectedLangugae)}}</div>
							</div>
							<div class="note-div notes pl-2">
								<span>
									{{$t('addListing.details.showOnMapNote',selectedLangugae)}}
								</span>
							</div>
						</b-col>
						
						<b-modal
							id="showgooglemap-model"
							class="listing-preview-dialog"
							title="Preview Listing"
							size="xl"
							scrollable
							hide-footer
							hide-header
							ref="showgooglemap-model"
							center
							no-close-on-backdrop
							no-close-on-esc
						>
							<div @click="cancel()" class="close-modal ">
								<CloseIcon style="font-size:32px;" />
							</div>
							<AreaSelection @initLatLng="getSelectedArea" v-if="!mapAreaSelected"></AreaSelection>
							<p v-if="mapAreaSelected" style="
								line-height: 1.5;
								font-weight: bolder;
								font-size: 20px;
							">
							{{$t('addListing.details.firstText',selectedLangugae)}} [ <img :alt="$t('Advertise with us Buy-Sell')" src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png" 
							draggable="false" style="width: 20px; height: 30px;"> ] - 
							{{$t('addListing.details.secondText',selectedLangugae)}} <br>{{$t('addListing.details.thirdText',selectedLangugae)}} [
							 <img :alt="$t('Advertise with us Buy-Sell')" src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2223%22%20height%3D%2238%22%20viewBox%3D%220%200%2023%2038%22%3E%0A%3Cpath%20d%3D%22M16.6%2C38.1h-5.5l-0.2-2.9-0.2%2C2.9h-5.5L5%2C25.3l-0.8%2C2a1.53%2C1.53%2C0%2C0%2C1-1.9.9l-1.2-.4a1.58%2C1.58%2C0%2C0%2C1-1-1.9v-0.1c0.3-.9%2C3.1-11.2%2C3.1-11.2a2.66%2C2.66%2C0%2C0%2C1%2C2.3-2l0.6-.5a6.93%2C6.93%2C0%2C0%2C1%2C4.7-12%2C6.8%2C6.8%2C0%2C0%2C1%2C4.9%2C2%2C7%2C7%2C0%2C0%2C1%2C2%2C4.9%2C6.65%2C6.65%2C0%2C0%2C1-2.2%2C5l0.7%2C0.5a2.78%2C2.78%2C0%2C0%2C1%2C2.4%2C2s2.9%2C11.2%2C2.9%2C11.3a1.53%2C1.53%2C0%2C0%2C1-.9%2C1.9l-1.3.4a1.63%2C1.63%2C0%2C0%2C1-1.9-.9l-0.7-1.8-0.1%2C12.7h0Zm-3.6-2h1.7L14.9%2C20.3l1.9-.3%2C2.4%2C6.3%2C0.3-.1c-0.2-.8-0.8-3.2-2.8-10.9a0.63%2C0.63%2C0%2C0%2C0-.6-0.5h-0.6l-1.1-.9h-1.9l-0.3-2a4.83%2C4.83%2C0%2C0%2C0%2C3.5-4.7A4.78%2C4.78%200%200%2C0%2011%202.3H10.8a4.9%2C4.9%2C0%2C0%2C0-1.4%2C9.6l-0.3%2C2h-1.9l-1%2C.9h-0.6a0.74%2C0.74%2C0%2C0%2C0-.6.5c-2%2C7.5-2.7%2C10-3%2C10.9l0.3%2C0.1%2C2.5-6.3%2C1.9%2C0.3%2C0.2%2C15.8h1.6l0.6-8.4a1.52%2C1.52%2C0%2C0%2C1%2C1.5-1.4%2C1.5%2C1.5%2C0%2C0%2C1%2C1.5%2C1.4l0.9%2C8.4h0Zm-10.9-9.6h0Zm17.5-.1h0Z%22%20style%3D%22fill%3A%23333%3Bopacity%3A0.7%3Bisolation%3Aisolate%22%2F%3E%0A%3Cpath%20d%3D%22M5.9%2C13.6l1.1-.9h7.8l1.2%2C0.9%22%20style%3D%22fill%3A%23ce592c%22%2F%3E%0A%3Cellipse%20cx%3D%2210.9%22%20cy%3D%2213.1%22%20rx%3D%222.7%22%20ry%3D%220.3%22%20style%3D%22fill%3A%23ce592c%3Bopacity%3A0.5%3Bisolation%3Aisolate%22%2F%3E%0A%3Cpath%20d%3D%22M20.6%2C26.1l-2.9-11.3a1.71%2C1.71%2C0%2C0%2C0-1.6-1.2H5.7a1.69%2C1.69%2C0%2C0%2C0-1.5%2C1.3l-3.1%2C11.3a0.61%2C0.61%2C0%2C0%2C0%2C.3.7l1.1%2C0.4a0.61%2C0.61%2C0%2C0%2C0%2C.7-0.3l2.7-6.7%2C0.2%2C16.8h3.6l0.6-9.3a0.47%2C0.47%2C0%2C0%2C1%2C.44-0.5h0.06c0.4%2C0%2C.4.2%2C0.5%2C0.5l0.6%2C9.3h3.6L15.7%2C20.3l2.5%2C6.6a0.52%2C0.52%2C0%2C0%2C0%2C.66.31h0l1.2-.4a0.57%2C0.57%2C0%2C0%2C0%2C.5-0.7h0Z%22%20style%3D%22fill%3A%23fdbf2d%22%2F%3E%0A%3Cpath%20d%3D%22M7%2C13.6l3.9%2C6.7%2C3.9-6.7%22%20style%3D%22fill%3A%23cf572e%3Bopacity%3A0.6%3Bisolation%3Aisolate%22%2F%3E%0A%3Ccircle%20cx%3D%2210.9%22%20cy%3D%227%22%20r%3D%225.9%22%20style%3D%22fill%3A%23fdbf2d%22%2F%3E%0A%3C%2Fsvg%3E%0A" aria-label="Street View Pegman Control" 
							 style="height: 30px; width: 30px;"> ] {{$t('addListing.details.fourthText',selectedLangugae)}}</p>
							 <div class="col-6 pl-0 mb-6" id="input-group-search" v-if="mapAreaSelected">
								<IconLocation class="icon-location2" />
								<google-autocomplete
									ref="autocomplete"
									:options="autocompleteOptions"
									@place_changed="processLocationChanged"
									:value="loclationAddress"
									class="input-search form-control"
									:placeholder="$t('Please Specify location')"
									:select-first-on-enter="true"
									style="padding-left:34px;"
								>
									<template v-slot:input="slotProps">
									<b-input-group class="mt-3">
										<b-input
										ref="input"
										class="input-search"
										v-on:listeners="slotProps.listeners"
										v-on:attrs="slotProps.attrs"
										></b-input>
									</b-input-group>
									</template>
								</google-autocomplete>
							</div>
							<div v-if="mapAreaSelected" style="position: relative;">
								<div class="location-button " >
									<b-button @click="getMyLocation()" class="get-location-button m-3">
										<IconLocation style="color:white;"/>
									</b-button>
								</div>
								<google-map
										
										ref="mapRef"
										:center="{ lat: lat, lng: lng }"
										:zoom="15"
										style="width: 100%;height:50vh"
										@click="putMarker($event)"
										:options="{
											zoomControl: true,
											mapTypeControl: false,
											scaleControl: true,
											streetViewControl: true,
											rotateControl: false,
											fullscreenControl: false,
											disableDefaultUI: true,
											gestureHandling:'greedy'
										}"
									>
										<google-marker
											ref="myMarker"
											:position="
												google &&
													new google.maps.LatLng(markerLat, markerLng)
											"
											:draggable="true"
											:clickable="true"
											:animation="1"
											@position_changed="getPosition($event)"
											@click="getPosition($event)"
										></google-marker>
								</google-map>
							</div>
								<div style="color:red" v-if="mapAreaSelected">
									{{$t('addListing.details.mapNote',selectedLangugae)}}
								</div>
								<div class="footer" v-if="mapAreaSelected">
									<!-- Emulate built in modal footer ok and cancel button actions -->
									<b-button class="cancel-button mr-5" style="width:150px;"  variant="danger" @click="cancel()">{{$t('addListing.details.cancel',selectedLangugae)}}</b-button>
									<b-button class="okay-button success-button mr-5" style="width:150px;"  variant="success" @click="ok()">{{$t('addListing.details.ok',selectedLangugae)}}</b-button>
									<!-- Button with custom close trigger value -->
								</div>
						</b-modal>
					</div>
					<!-- Province / District -->
					<div class="form-group row">
						<label class="col-3 required-label">{{
							$t(childCategories.field_name_location)
						}}</label>
						<b-col cols="9">
							<div class="input-div row">
								<b-col cols="6" class="pl-15">
									<b-dropdown no-flip
										class="menu-dropdown"
										:class="{
											'input-error': validateErrors
												? validateErrors.state
												: false
										}"
									>
										<template v-slot:button-content>
											<span>
												{{
													listing.state
														? $t(listing.state.name)
														: $t('addListing.details.province',selectedLangugae)
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											v-for="(province, key) in arrListProvince"
											v-bind:key="key"
											@click="handleProvinceChange(province)"
											>{{ $t(province.name) }}</b-dropdown-item
										>
									</b-dropdown>
								</b-col>
								<b-col cols="6" class="pr-15">
									<b-dropdown no-flip
										class="menu-dropdown"
										:disabled="!listing.state"
										:class="{
											'input-error': validateErrors
												? validateErrors.district
												: false
										}"
									>
										<template v-slot:button-content>
											<span>
												{{
													listing.district
														? $t(listing.district.name)
														: $t('addListing.details.district',selectedLangugae)
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											v-for="(district, key) in arrListDistrict"
											v-bind:key="key"
											@click="listing.district = district"
											>{{ $t(district.name) }}</b-dropdown-item
										>
									</b-dropdown>
								</b-col>
							</div>
						</b-col>
					</div>
					<!-- Contact -->
					<div class="form-group make-label-start row">
						<label class="col-3">{{
							$t('addListing.details.contactDetails',selectedLangugae)
						}}</label>
						<b-col cols="9">
							<div class="email-div row">
								<b-col cols="12">
									<b-form-checkbox v-model="listing.takeContactFromDashboard">{{
										$t('addListing.details.takeFromDashboard',selectedLangugae)
									}}</b-form-checkbox>
								</b-col>
								<b-col cols="12">
									<div class="input-div row no-gutters">
										<b-col cols="6" style="padding:0;padding-left:8px;">
											<b-form-input
												:placeholder="$t('user.email',selectedLangugae)"
												class="input-search"
												:class="{
													'input-error': validateErrors
														? validateErrors.phoneAndEmail
														: false
												}"
												v-model="listing.email"
												:disabled="listing.takeContactFromDashboard"
												style="width: 333px;"
											></b-form-input>
										</b-col>
										<b-col cols="6" ss="px-3" style="padding-right:0">
											<b-form-input
												:placeholder="$t('phone number (only numbers)')"
												class="input-search"
												:class="{
													'input-error': validateErrors
														? validateErrors.phoneAndEmail
														: false
												}"
												type="number"
												v-model="listing.phoneNumber"
												:disabled="listing.takeContactFromDashboard"
												style="width: 333px;"
											></b-form-input>
										</b-col>
										
									</div>
								</b-col>
							</div>
						</b-col>
					</div>
					<div class="form-group make-label-start row">
						<label class="col-3 p-0">{{
							$t('line',selectedLangugae)
						}}
						<img :alt="$t('Advertise with us Buy-Sell')" src="/images/line.png" style="width: 35px;height:35px; margin-left: 10px;margin-right: 20px;margin-top: 5px;"/>
						</label>
						<b-col cols="9">
							<div class="email-div row">
								<b-col cols="12">
									<div class="input-div row no-gutters">
										<b-col cols="6" style="padding:0;padding-left:8px;">
											<b-form-input
												:placeholder="$t('line')"
												class="input-search"
												v-model="listing.line_id"
												:disabled="listing.takeContactFromDashboard"
												style="width: 333px;"
											></b-form-input>
										</b-col>
									</div>
								</b-col>
							</div>
						</b-col>
					</div>
					<!-- Packages -->
					<b-modal
						id="package-model"
						class="package-model"
						title="Preview Listing"
						size="xl"
						scrollable
						hide-footer
						hide-header
						ref="package-model"
						center
						no-close-on-backdrop
						no-close-on-esc
						>
						<div class="package-model">
							<Packages
								v-if="arrUserPayment || $route.name === 'AddListing'"
								@childToParent="getSelectedPackages"
								:userPayment="arrUserPayment"
								:website="listing.website"
							/>
							<div class="footer" >
								<!-- Emulate built in modal footer ok and cancel button actions -->
								<b-button class="cancel-button mr-5" style="width:150px;border: 1px solid var(--projectPrimaryColor)!important;background-color: white!important;color: var(--projectPrimaryColor) !important;"  variant="danger" 
									@click="toggleAdsImag()">{{$t('addListing.details.skipPackage')}}</b-button>
								<b-button class="okay-button success-button mr-5" style="width:150px;"  variant="success" 
								@click="addPackage(false)" :disabled="disabledPackageButton">{{$t('addListing.details.ok')}}</b-button>
								<!-- Button with custom close trigger value -->
							</div>
						</div>
					</b-modal>
					<b-modal
						id="image-ads-model"
						class="image-ads-model"
						hide-footer
						hide-header
						ref="image-ads-model"
						centered
						size="md"
						no-close-on-backdrop
						no-close-on-esc
						>
							
							<div style="position: relative;">
								<img :src="'/images/popup/ads-image-'+selectedLanguage+'.png'"/>
								<img :src="'/images/popup/upgrade.png'"
								style="position: absolute;right: -31px;top:34px;cursor: pointer;" @click="openPakcageDialog()"/>
								<img :src="'/images/popup/no-'+selectedLanguage+'.png'"  
								style="position: absolute;left: 50px;bottom: 45px;cursor: pointer;" @click="addPackage(true)"/>
								<img :src="'/images/popup/yes-'+selectedLanguage+'.png'"
								style="position: absolute;right: 20px;bottom: 34px;cursor: pointer;" @click="openPakcageDialog()"/>
								
							</div>
					</b-modal>
					<!-- Submit btn -->
					<div class="button-div">
						<div>
							{{ $t('addListing.details.clickPostToAccept') }}
							<router-link id="goHome" :to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"><span>{{ $t('addListing.details.termsCondition') }}</span></router-link>
						</div>
						<b-button
							type="button"
							class="btn-submit-search"
							@click="openPakcageDialog()"
							:disabled="disabled"
							>{{ $t('addListing.details.post') }}</b-button
						>
					</div>

					<b-modal
						id="listing-preview-dialog-first"
						centered
						hide-footer
						hide-header
						size="lg"
						no-close-on-backdrop
					>
						<b-container fluid>
							<div class="preview-div">
								<div class="icon-div">
									<IconClipboardText />
								</div>

								<h4>{{ $t('addListing.details.listingUnderReview') }}</h4>
								<!-- <p style="margin-bottom:0;">{{ $t('addListing.details.listingPreviewText') }}</p> -->
								<p style="margin-bottom:0;">
									{{$t('please click')}}
									<b>{{$t('Confirm the announcement')}}</b> {{$t('to complete the posting process.')}}
								</p>
								<p>{{ $t('addListing.details.listingPreviewText1') }}</p>
								<div class="button-div">
									<b-button
										class="btn-submit-search extra-background-color-button"
										@click="previousEditListing"
										>{{ $t('addListing.details.editProductButton') }}</b-button
									>
									<b-button
										type="submit"
										class="btn-submit-search extra-background-color-button"
										@click="previewAddListing"
										id="previewListing"
										>{{ $t('addListing.details.previewButton') }}</b-button
									>
									<b-modal
										id="preview-model"
										class="listing-preview-dialog"
										title="Preview Listing"
										size="xl"
										scrollable
										hide-header
										no-close-on-backdrop
									>
										<ListingDetail :listingDetailsFront="arrListPreview" />
										<template v-slot:modal-footer="{ ok }">
											<div class="footer">
												<!-- Emulate built in modal footer ok and cancel button actions -->
												<b-button
													variant="success"
													@click="
														ok();
														
													"
													style="border:1px solid var(--projectPrimaryColor)!important; color: var(--projectPrimaryColor)!important;
													width: 178px;
													border-radius: var(--borderRadius);
													margin-right: 25px;
													margin-top: 22px;"
													>{{$t('OK')}}</b-button
												>
												<!-- <b-button
													variant="danger"
													class="cancel-button"
													@click="
														cancel();
														
													"
													style="background: var(--projectPrimaryColor)!important; color:white;
													width: 178px;
													border-radius: var(--borderRadius);
													margin-right: 25px;
													margin-top: 22px;"
													>{{$t('Cancel')}}</b-button
												> -->
												<!-- Button with custom close trigger value -->
											</div>
										</template>
									</b-modal>
									<!-- v-on:click="previewDialog();secondStep = true;firstStep=false;" -->
									<b-button
										type="submit"
										class="btn-submit-search"
										v-on:click="skipAddListing"
										id="confirmAddListing"
										>{{ $t('addListing.details.skipButton') }}</b-button
									>
								</div>
							</div>
						</b-container>
					</b-modal>
				</b-form>

				<!-- SECOND STEP -->

				<!-- THIRD STEP -->
				<div class="review-listing" v-else-if="secondStep">
					<div class="icon-div">
						<ClockOutlineIcon />
					</div>
					<p>{{ $t('addListing.details.reviewText') }}</p>
					<div class="wrap-redirect-btn">
						<router-link id="goHome" :to="$i18nRoute({ name: '' })">
							<b-button class="go-home">{{$t('back to home page')}}</b-button>
						</router-link>
						<router-link
							id="goDashboard"
							:to="$i18nRoute({ name: 'user-dashboard' })"
						>
							<b-button class="go-dashboard">{{$t('go to control panel')}}</b-button>
						</router-link>
					</div>
				</div>
			</div>
		</b-container>
		<b-modal id="trasnlatation-error"
				centered
				hide-footer
				hide-header
				size="md"
				no-close-on-backdrop>
				<b-container fluid class="d-flex flex-column  align-items-center justify-content-center mt-3">
					<p style="text-align:center" class="w-70 d-flex flex-row align-self-center align-items-center justify-content-center">{{$t('Please complete the announcement details Other languages will be enabled When you fill out the required information to place an announcement only fully')}}</p>
					<b-button class="success-button" @click="closeTranslationDialog">{{$t('OK')}}</b-button>
				</b-container>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { gmapApi } from 'vue2-google-maps';
import MaskedInput from 'vue-text-mask';
import _ from "lodash";
import UserMenuDropdown from '@/components/ui/UserMenuDropdown';
import ListingDetail from '@/components/listing/listingDetail/ListingDetail';
import AreaSelection from '@/components/ui/areaSelection/AreaSelection';
import { Trans } from '@/plugins/Translation';

// Icons
import { BIconQuestionCircle } from 'bootstrap-vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import IconUserPlus from '@/components/icons/IconUserPlus/index';
import IconLocation from '@/components/icons/IconLocation/index';
import Packages from '@/components/packages/Packages';
import Fileuploader from '@/components/newFileuploader/index';
import IconClipboardText from '@/components/icons/IconClipboardText/index';
import ClockOutlineIcon from 'vue-material-design-icons/ClockOutline.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import IconLogin from '@/components/icons/IconLogin/index';
import CloseIcon from 'vue-material-design-icons/Close.vue';

export default {
	components: {
		BIconQuestionCircle,
		PencilIcon,
		// MagnifyIcon,
		CheckIcon,
		Packages,
		Fileuploader,
		IconClipboardText,
		ClockOutlineIcon,
		ListingDetail,
		ChevronDownIcon,
		IconLogin,
		MaskedInput,
		UserMenuDropdown,
		AreaSelection,
		IconLocation,
		CloseIcon
	},
	data() {
		return {
			autocompleteOptions: {
				componentRestrictions: {
					country: ["th"],
				},
			},
			disabledPackageButton:true,
			supportedLanguages:[],
			selectedLangugae:null,
			mapAreaSelected:false,
			lat: 13.7563,
      		lng: 100.5018,
			gmapApi:null,
			map: null,
			markerLat: 13.7563,
			markerLng: 100.5018,
			loclationAddress:null,
			postal_code:null,
			country:null,
			disabled: false,
			hideFileUploader: false,
			categoryFirstChange: false,
			provinceFirstChange: false,
			firstStep: true,
			secondStep: false,
			thirdStep: false,
			listing: {
				phoneNumber: null,
				line_id: null,
				takeContactFromDashboard: true,
				email: null,
				price: null,
				description: null,
				keywords: null,
				state: null,
				district: null,
				mainCategory: {
					key: 33,
					idCategory: 33,
					name: this.$t('housing')
				},
				subCategory: null,
				subSubCategory: null,
				title: null,
				listingAttr: {
					data: {}
				},
				package_detail_ids: '',
				affiliate_dates_ids: '',
				listingImage: [],
				website: null,
				listing_category_id: null
			},
			listingInOther:{},
			childCategories: {
				listing_category_children:[],
				childSubCategory: {
					listing_category_children:[]
				},
			},
			dropdownChooseValue: {},
			listListingJustCreated: {},
			validateErrors: {},
			validateInputDynamic: [null],
			isValidate: false,
			countError: 0,
			arrImageUploaded: [],
			arrUserPayment: null,
			userName:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).display_name
					? JSON.parse(localStorage.getItem('user_profile')).display_name
					: '',
			isAdmin:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
					'Admin'
					? true
					: false
		};
	},
	computed: {
		...mapGetters('SiteConfigController', ['projectConfig']),
		...mapGetters('AddListingController', ['arrListProvince', 'valueRedirect']),
		...mapState('AddListingController', [
			'arrListDistrict',
			'arrListCategoryChildChild',
			'arrListCategoryChild',
			'arrListPreview',
			'listingJustCreated'
		]),
		...mapGetters('CategoryController', ['categoriesOptions']),
		google: gmapApi,
		selectedLanguage(){
			return Trans.currentLanguage
		}
	},
	created() {
		this.selectedLangugae=Trans.currentLanguage;
		Trans.supportedLanguages.forEach((elm,index)=>{
			if(elm==Trans.currentLanguage){
				this.supportedLanguages=this.moveArrayItemToNewIndex(Trans.supportedLanguages,index,0);
			}
		})
		
		this.GET_CATEGORY();

		this.GET_LIST_PROVINCES({
			take: -1,
			page: 1
		});
		// Get the listing details if in edit mode
		if (this.$route.params.id) {
			this.getListingEdit();
		} else {
			this.GET_CATEGORY_CHILD_BY_ID(this.listing.mainCategory.key);
			this.getContactDetails();
		}
	},
	mounted() {
		if(!this.$root.isAuthenticated){
			this.$root.signIn('add-listing');
		}
		if (this.valueRedirect) {
			this.firstStep = false;
			// this.secondStep = false;
			this.secondStep = true;
			this.$store.commit(
				'AddListingController/VALUE_WHEN_REDIRECT_ADD_LISTING',
				false
			);
		}
		this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
			if (modalId == 'modal-center') {
				// this.hideFileUploader = false;
			}
		});
	},
	watch: {
		'listing.package_detail_ids'(val){
			console.log("val",val)
			if(val.length){
				if(val.indexOf(10)>-1&&!this.listing.website){
					this.disabledPackageButton=true;
					this.$forceUpdate();
				}else{
					this.disabledPackageButton=false;
					this.$forceUpdate();
				}
			}else{
				this.disabledPackageButton=true;
				this.$forceUpdate();
			}
		},
		'listing.website'(val){
			if (val.match('https://') || val.match('http://')) {
				this.disabledPackageButton = false;
				this.$forceUpdate();
				return;
			} else {
				this.disabledPackageButton = true;
				this.$forceUpdate();
			}
		},
		// 'Hacky' way (render error otherwise) need a proper loading management
		arrListCategoryChild(val) {
			this.childCategories = val;
			this.childCategories.childSubCategory={listing_category_children:[]};
			this.listing.listingAttr.data={};
			this.$forceUpdate();
		},
		arrListCategoryChildChild(val) {
			this.childCategories.childSubCategory = val;
			if(this.listing.mainCategory.idCategory==34){
				console.log("arrListCategoryChildChild")
				this.childCategories.category_attribute_details = val.category_attribute_details;
				this.$forceUpdate();
				this.listing.listingAttr.data={};
				this.$forceUpdate();
			}
			this.$forceUpdate();
		},
		'arrListCategoryChild.listing_category_children'(newVal) {
			if ((!this.$route.params.id|| this.categoryFirstChange) && newVal.length!=0) {
				this.listing.subCategory = {
					id: newVal[0].id,
					name: newVal[0].name
				};
				this.$forceUpdate();
			}
		},
		'arrListCategoryChildChild.listing_category_children'(newVal) {
			if ((!this.$route.params.id|| this.categoryFirstChange) && newVal.length!=0) {
				this.listing.subsubcategory = {
					id: newVal[0].id,
					name: newVal[0].name
				};
				this.$forceUpdate();
			}
		},
		
		categoriesOptions(val) {
			this.listing.mainCategory.idCategory = val[0].id;
			this.listing.mainCategory.name = val[0].name;
		},
		arrListDistrict(newVal) {
			//  Set default value if in addListing or the province is changed
			if (!this.$route.params.id || this.provinceFirstChange) {
				this.listing.district = newVal[0];
			}
		},
		'listing.takeContactFromDashboard': function(val) {
			if (val) {
				this.getContactDetails();
			}
		},
		'listing.state': function(data) {
			this.GET_LIST_DISTRICTS({
				take: -1,
				page: 1,
				province_id: data.id
			});
		},
		'listing.mainCategory.idCategory': function(idCategory) {
			console.log("this.arrListPreview.id",this.arrListPreview.id)
			console.log("this.arrListPreview.id",this.categoryFirstChange||this.arrListPreview.id)
			if (!this.$route.params.id || this.categoryFirstChange ) {
				this.GET_CATEGORY_CHILD_BY_ID({id:idCategory,type:false});
				this.listing.listingAttr.data={};
			}
		},

		'listing.subCategory'(newVal){
			if (!this.$route.params.id || this.categoryFirstChange ) {
				this.listing.subSubCategory = {};
				this.childCategories.childSubCategory = {listing_category_children:[]};
				if(newVal){
					this.GET_CATEGORY_CHILD_BY_ID({id:newVal.id,type:true});
				}
				
			}else{
				if(newVal.id){
					this.GET_CATEGORY_CHILD_BY_ID({id:newVal.id,type:true});
				}
			}
			
		},
		
		listingJustCreated: function(val) {
			console.log("val",val)
			this.listListingJustCreated = val;
		},
		'arrListCategoryChild.category_attribute_details'(val) {
			//  Set default value if in addListing or main category is changed
			if (!this.$route.params.id || this.categoryFirstChange) {
				this.fillAttributes(val);
			}
			
		},
		arrListPreview(val) {
			console.log("arrListPreview val",val)
			setTimeout(()=>{
				for (const item of val.listing_attributes_details) {
					if (
						item.listing_attribute.listing_attributes_type.id == 5
					) {
						this.listing.listingAttr.data[`checkboxValue_${item.attr_id}`] =!Boolean(item.value);
						this.childCategories.category_attribute_details.forEach((elt)=>{
							if(elt.listing_attribute.listing_attributes_children.length){
								elt.listing_attribute.listing_attributes_children.forEach((subElt)=>{
									if(subElt.listing_attributes_type.id == 5){
										if(subElt.id==item.attr_id){
											elt.listing_attribute.disabled=this.listing.listingAttr.data[`checkboxValue_${item.attr_id}`];
											this.$forceUpdate();
										}
									}
								})
							}
						})
					}
					if (
						item.listing_attribute.listing_attributes_type.id == 1 ||
						item.listing_attribute.listing_attributes_type.id == 4
					) {
						this.listing.listingAttr.data[`inputValue_${item.attr_id}`] =
							item.value;
							this.$forceUpdate();
					}
					if (item.listing_attribute.listing_attributes_type.id == 2) {
						console.log("radio button",item.pre_values_id)
						this.listing.listingAttr.data[`radioValue_${item.attr_id}`] = item.pre_values_id;
						this.$forceUpdate();
						console.log("this.listing.listingAttr.data[`radioValue_${item.attr_id}`]",this.listing.listingAttr.data[`radioValue_${item.attr_id}`])
					}
					if (item.listing_attribute.listing_attributes_type.id == 3) {
						this.listing.listingAttr.data[`selectValue_${item.attr_id}`] = item.pre_values_id;
						this.$forceUpdate();
						this.dropdownChooseValue[`selectValue_${item.attr_id}`] = item.listing_pre_value.value;
						this.$forceUpdate();
					}
				}
			},1000)
			this.arrImageUploaded = [];
			this.$forceUpdate();
			this.listing.listingAttr.data={};
			this.listing.id=val.id;
			console.log("this.depthOfObject(val.listing_category)",this.depthOfObject(val.listing_category))
			if(this.depthOfObject(val.listing_category)==3&&val.listing_category.listing_category_parent.listing_category_parent){
				console.log("if")
				this.listing.mainCategory = {
					idCategory: val.listing_category.listing_category_parent.listing_category_parent.id,
					name: val.listing_category.listing_category_parent.listing_category_parent.name
				};

				setTimeout(()=>{
					this.listing.subCategory = {
						id: val.listing_category.listing_category_parent.id,
						name: val.listing_category.listing_category_parent.name
					};
					this.listing.subSubCategory = {
						id: val.listing_category.id,
						name: val.listing_category.name
					};
				},200)
			}else {
				console.log("elsess")
				this.listing.mainCategory = {
					idCategory: val.listing_category.listing_category_parent?val.listing_category.listing_category_parent.id:val.listing_category.id,
					name: val.listing_category.listing_category_parent?val.listing_category.listing_category_parent.name:val.listing_category.name,
				};
				if(val.listing_category.listing_category_parent){
					this.listing.subCategory = {
						id: val.listing_category.id,
						name: val.listing_category.name
					};
				}else{
					this.listing.subCategory = {
						id: null,
						name: null
					};
				}
			}
			this.GET_CATEGORY_CHILD_BY_ID({id:this.listing.mainCategory.idCategory,type:false});
			console.log("this.listing",this.listing)
			this.listing.title = val.title;
			this.listing.price = val.price.toString();
			this.listing.description = val.description;
			this.listing.state = val.province;
			this.listing.district = val.district;
			this.listing.phoneNumber = val.phone;
			this.listing.line_id = val.line_id;
			this.listing.email = val.email;
			this.listing.website = val.website;
			this.lat=val.lat;
			this.lng=val.lon;
			this.markerLat=val.lat;
			this.markerLng=val.lon;
			if(!val.formatted_address || val.formatted_address==''){
				this.decodeLatLong();
			}else{
				this.loclationAddress=val.formatted_address;
			}
			this.postal_code=val.postal_code;
			this.country=val.country;
			this.listing.formatted_address = val.formatted_address;
			if (val.keywords) {
				let arrKeywords = val.keywords.split(',');


				this.listing.keywords = arrKeywords;
			}
			if (val.user_payments.length) {
				
				let result = val.user_payments.filter(
					(temp) =>
						temp.status == 1 ||
						temp.status == 2 ||
						temp.status == 4 ||
						temp.status == 7
				);
				if (result) {
					this.arrUserPayment = [];
					let arr = [];
					let datesArr = [];
					result.forEach(payment => {
						console.log('RESULT ', payment.user_payments_details);
						this.arrUserPayment.push(payment.user_payments_details);
						payment.user_payments_details.forEach(elm=>{
							if (elm.package_detail_id) {
								arr.push(elm.package_detail_id);
							}
						})
						if(payment.affiliate_book_dates.length){
							payment.affiliate_book_dates.forEach(date => {
								datesArr.push(date.id);
							});
						}
						
					});
					this.listing.package_detail_ids = arr.toString();
					this.listing.affiliate_dates_ids = datesArr.toString();
					console.log('this.listing.package_detail_ids ', this.listing.package_detail_ids);
					this.listing.user_payments=val.user_payments;
					this.listListingJustCreated.user_payments=val.user_payments;
					this.arrUserPayment = result;
				} else {
					this.arrUserPayment = [];
					this.listing['user_payments']=[];
					this.listListingJustCreated['user_payments']=[];
				}
			} else {
				this.arrUserPayment = [];
				this.listing['user_payments']=[];
				this.listListingJustCreated['user_payments']=[];
			}
			if (val.url_feature_image) {
				this.arrImageUploaded.push(val.url_feature_image);
			}
			if (val.listing_images.length) {
				val.listing_images.map(value => {
					this.arrImageUploaded.push(value.url_image);
				});
			}
			
		},
		'listing.keywords': function(val) {
			if (val.length > 5) {
				this.listing.keywords.length = 5;
				this.makeToastError(this.$t('editListing.keywords.maxKeyword'));
			}
		},
		'$root.isAuthenticated':{
			deep: true,
			handler: _.debounce(function (val) {
				console.log("$root.isAuthenticated watch",val)
					if (val) {
						setTimeout(() => {
							this.userName = JSON.parse(
								localStorage.getItem('user_profile')
							).first_name;
						}, 500);
					}else{
						this.$root.signIn('add-listing');
					}
			}, 800),
			
		},
	},
	methods: {
		...mapActions('AddListingController', [
			'GET_LIST_PROVINCES',
			'GET_LIST_DISTRICTS',
			'GET_CATEGORY_CHILD_BY_ID',
			'USER_ADD_LISTING',
			'GET_LISTING_PREVIEW',
			'USER_UPDATE_LISTING',
			'USER_CONFIRM_LISTING',
			'TRANSLATE_LISTING'
		]),
		...mapActions('CategoryController', ['GET_CATEGORY']),
		moveArrayItemToNewIndex(arr, old_index, new_index) {
			if (new_index >= arr.length) {
				var k = new_index - arr.length + 1;
				while (k--) {
					arr.push(undefined);
				}
			}
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			return arr; 
		},
		depthOfObject(object) {
			var level = 1;
			for(var key in object) {
				if (!object.hasOwnProperty(key)) continue;

				if(typeof object[key] == 'object'){
					var depth = this.depthOfObject(object[key]) + 1;
					level = Math.max(depth, level);
				}
			}
			return level;
		},
		getSelectedArea(ev){
			this.mapAreaSelected=true;
			this.lat=ev.lat;
			this.lng=ev.lng;
			this.markerLat=ev.lat;
			this.markerLng=ev.lng;
		},
		getContactDetails() {
			if (
				localStorage &&
				JSON.parse(localStorage.getItem('user_profile')).email
			) {
				this.listing.email = JSON.parse(
					localStorage.getItem('user_profile')
				).email;
			}
			if (
				localStorage &&
				JSON.parse(localStorage.getItem('user_profile')).telephone
			) {
				this.listing.phoneNumber = JSON.parse(
					localStorage.getItem('user_profile')
				).telephone;
			}
			if (
				localStorage &&
				JSON.parse(localStorage.getItem('user_profile')).line_id
			) {
				this.listing.line_id = JSON.parse(
					localStorage.getItem('user_profile')
				).line_id;
			}
		},

		handleProvinceChange(province) {
			this.listing.state = province;
			this.provinceFirstChange = true;
		},

		fillAttributes(array) {
			this.listing.listingAttr.data = {};
			this.validateErrors = {};
			this.validateInputDynamic = [];
			for (const item of array) {
				if (item.listing_attribute.listing_attributes_type.id == 2) {
					this.listing.listingAttr.data[`radioValue_${item.attr_id}`] =
						item.listing_attribute.listing_pre_values[0].id;
				} else if (item.listing_attribute.listing_attributes_type.id == 3) {
					this.listing.listingAttr.data[`selectValue_${item.attr_id}`] =
						item.listing_attribute.listing_pre_values[0].id;
					this.dropdownChooseValue[`selectValue_${item.attr_id}`] =
						item.listing_attribute.listing_pre_values[0].value;
				} else if (item.listing_attribute.listing_attributes_type.id == 1) {
					for (const child of item.listing_attribute
						.listing_attributes_children) {
						if (child.listing_attributes_type.id === 3) {
							this.listing.listingAttr.data[`selectValue_${child.id}`] =
								child.listing_pre_values[0].id;
							this.dropdownChooseValue[`selectValue_${child.id}`] =
								child.listing_pre_values[0].value;
						}
					}
				}
				 else if (item.listing_attribute.listing_attributes_type.id == 4) {
					for (const child of item.listing_attribute
						.listing_attributes_children) {
						if (child.listing_attributes_type.id == 3) {
							this.listing.listingAttr.data[`selectValue_${child.id}`] =
								child.listing_pre_values[0].id;
							this.dropdownChooseValue[`selectValue_${child.id}`] =
								child.listing_pre_values[0].value;
						}
						if (child.listing_attributes_type.id == 5) {
							this.listing.listingAttr.data[`checkboxValue_${child.id}`];
							
						}
					}
				}
			}
		},

		getFile(ev) {
			this.listing.listingImage = ev;
		},

		async getListingForSubmit(removePackage) {
			if (!this.countError) {
				this.$emit('loading', true);

				Object.keys(this.listing.listingAttr.data).forEach(item => {
					const splitID = item.split('_');
					if (splitID[1] == 16) {
						this.listing.price = this.listing.listingAttr.data[
							`inputValue_${splitID[1]}`
						];
					}
				});
				if (this.listing.price.indexOf(',') !== -1) {
					this.listing.price = this.listing.price.replace(/,/g, '');
				}
				console.log("this.listing",this.listing)
				// create the listing object
				const listing = {
					title: this.listing.title,
					description: this.listing.description,
					price: +this.listing.price,
					listing_category_id: this.listing.subSubCategory&&this.listing.subSubCategory.id?this.listing.subSubCategory.id:this.listing.subCategory&&this.listing.subCategory.id?this.listing.subCategory.id:this.listing.mainCategory.idCategory,
					subCategory: this.listing.subCategory&&this.listing.subCategory.id?this.listing.subCategory.id:null,
					subSubCategory: this.listing.subSubCategory&&this.listing.subSubCategory.id?this.listing.subSubCategory.id:null,
					province_id: this.listing.state.id,
					district_id: this.listing.district.id,
					email: this.listing.email,
					phone: this.listing.phoneNumber,
					line_id: this.listing.line_id,
					keywords: this.listing.keywords,
					listingAttr: this.listing.listingAttr,
					package_detail_ids: this.listing.package_detail_ids,
					affiliate_dates_ids: this.listing.affiliate_dates_ids,
					listing_image: this.listing.listingImage,
					website: this.listing.website,
					lat:this.markerLat,
					lng:this.markerLng,
					formatted_address:this.loclationAddress,
					postal_code:this.postal_code,
					country:this.country,
				};
				if(removePackage){
					listing.package_detail_ids=[]
					listing.package_detail_ids=null
					listing.website=null
				}
				// Post a new listing
				if (!this.listListingJustCreated.id && this.$route.name === 'AddListing') {
					this.USER_ADD_LISTING(listing)
						.then(item => {
							this.$emit('loading', false);
							let dialog = this.$bvModal.show('listing-preview-dialog-first');

							// this.secondStep = true;
							// this.firstStep = false;
							window.scroll(0, 0);
						})
						.catch(error => {
							console.log(error);
							if (error.data.detail === 'PREBOOKING_DATES_EXPIRED') {
								this.makeToastError(this.$t('packages.datesError'));
							} else {
								this.makeToastError(this.$t('Error one or more fields are invalid'));
							}
							this.$emit('loading', false);
						});
				} else {
					// Update an existing listing
					this.USER_UPDATE_LISTING({
						id: this.$route.params.id,
						...listing
					})
						.then(item => {
							this.$emit('loading', false);
							this.$bvModal.show('listing-preview-dialog-first');
							// this.secondStep = true;
							// this.firstStep = false;
							window.scroll(0, 0);
						})
						.catch(error => {
							if (error.data.detail === 'PREBOOKING_DATES_EXPIRED') {
								this.makeToastError(this.$t('packages.datesError'));
							} else {
								this.makeToastError(this.$t('Error one or more fields are invalid'));
							}
							this.$emit('loading', false);
						});
				}
			} else {
				this.makeToastError(this.$t('Please enter the required details'));
			}
		},
		hideModal(id, category, idCategory, name) {
			// if main category is changed enable the edit to set default value
			this.categoryFirstChange = true;
			this.listing.mainCategory.key = category;
			this.listing.mainCategory.idCategory = idCategory;
			this.listing.mainCategory.name = name;
			this.listing.subCategory = null;
			this.listing.subSubCategory = null;
			this.listing.listingAttr.data = {};
			this.validateErrors = {};
			console.log("this.childCategories",this.childCategories)
			// this.childCategories={listing_category_children:[]};
		 	// this.childCategories.childSubCategory={};
			
			this.validateInputDynamic = [];
			this.$root.$emit('bv::hide::modal', id);
		},
		getSelectedPackages(ev) {
			console.log("ev",ev)
			let objectID = JSON.parse(JSON.stringify(ev));
			// update package_detail_ids
			this.listing.package_detail_ids = '';
			let arr = [];
			Object.values(ev.packagesValue).forEach(pack => {
				if (pack.packagesDetails) {
					arr.push(pack.packagesDetails.id);
				}
			});
			this.listing.package_detail_ids = arr.toString();
			// update website url
			this.listing.website = objectID.websiteUrl;
			// submit btn disabling
			this.disabled = objectID.disabled;
			let datesArr = [];
			ev.preBookedDates.forEach(date => {
				datesArr.push(date.id);
			});
			this.listing.affiliate_dates_ids = datesArr.toString();
			this.$forceUpdate();
		},
		openKhaosodLogin() {
			this.$root.signIn('add-listing');
		},

		openPakcageDialog() {
			this.$bvModal.hide('image-ads-model');
			this.checkForm();
			if(!this.countError){
				this.$bvModal.show('package-model');
			}else{
				this.makeToastError(this.$t('Please enter the required details'));
			}
		},
		cancelPackage(){
			this.$bvModal.hide('package-model');
		},
		toggleAdsImag(){
			this.cancelPackage();
			this.$bvModal.show('image-ads-model');
		},
		addPackage(removePackage){
			this.cancelPackage();
			this.$bvModal.hide('image-ads-model');
			this.getListingForSubmit(removePackage);
		},
		skipAddListing() {

			this.$emit('loading', true);
			
			console.log("this.listListingJustCreated",this.listListingJustCreated)
			const payment = this.listListingJustCreated.user_payments;
			console.log("payment",payment)
			this.USER_CONFIRM_LISTING(this.listListingJustCreated.id)
				.then(result => {
					this.$emit('loading', false);
					if (payment && payment.length) {
						let result = payment.find(temp => temp.status == 1);
						if (result) {
							this.$router.push(
								this.$i18nRoute({ name: 'payment' }) + result.id
							);
						} else {
							this.$bvModal.hide('listing-preview-dialog-first');
							this.secondStep = true;
							this.firstStep = false;
							this.$forceUpdate();
						}
					} else {
						this.$bvModal.hide('listing-preview-dialog-first');
						this.secondStep = true;
						this.firstStep = false;
						this.$forceUpdate();
					}
				})
				.catch(error => {
					console.log('error', error);
					this.$emit('loading', false);
					this.secondStep = false;
					this.firstStep = true;
					this.$forceUpdate();
				});
		},
		checkForm(e) {
			console.log('this.listing   sssss', this.listing);
			this.listing.description=this.listing.description?this.listing.description.trim():this.listing.description;
			this.countError = 0;
			this.validateErrors = {};
			this.validateInputDynamic = [];
			this.isValidate = true;
			if (this.listing.title && this.listing.title.match(/[\u1000-\uFFFF]+/g)) {
				this.validateErrors[`title`] = true;
				this.countError++;
				console.log("titletitle ")
				this.makeToastError(this.$t('Marks or special characters are not allowed'));
				return;
			}
			if (!this.listing.title) {
				this.validateErrors[`title`] = true;
				this.countError++;
				console.log("title")
			}
			console.log("(!this.listing.subCategory||!this.listing.subCategory.id)",(!this.listing.subCategory||!this.listing.subCategory.id))
			if ((this.listing.mainCategory.idCategory!==35&&this.listing.mainCategory.idCategory!==36)&&(!this.listing.subCategory || !this.listing.subCategory.id)) {
				this.validateErrors[`idSubListing`] = true;
				this.countError++;
				console.log("idSubListing")
			}
			if(this.listing.mainCategory.idCategory==34&&
				((!this.listing.subCategory&&this.listing.subCategory.id!=42)&&(!this.listing.subSubCategory||!this.listing.subSubCategory.id))){
				this.validateErrors[`idsubSubListing`] = true;
				this.countError++;
			}

			if(this.listing.mainCategory.idCategory!==35&&(!this.listing.subCategory||!this.listing.subCategory.id)){
				this.validateErrors[`idSubListing`] = true;
				this.countError++;
			}
			if (!this.listing.description) {
				this.validateErrors[`description`] = true;
				this.countError++;
				console.log("description")
			}
			if (!this.listing.state) {
				this.validateErrors[`state`] = true;
				this.countError++;
				console.log("state")
			}
			if (!this.listing.district) {
				this.validateErrors[`district`] = true;
				this.countError++;
				console.log("district")
			}
			if (!this.listing.email && !this.listing.phoneNumber) {
				this.validateErrors[`phoneAndEmail`] = true;
				this.countError++;
				console.log("phoneAndEmail")
			}

			if (
				(this.listing.listingAttr.data.radioValue_18 &&
					this.listing.listingAttr.data.radioValue_18 == 53) ||
				this.listing.listingAttr.data.radioValue_18 == 54 ||
				this.listing.listingAttr.data.radioValue_18 == 55
			) {
				delete this.listing.listingAttr.data['inputValue_15'];
				delete this.listing.listingAttr.data['inputValue_16'];
				this.$forceUpdate();
			}
			if (Object.keys(this.listing.listingAttr.data).length) {
				Object.keys(this.listing.listingAttr.data).forEach((name, index) => {
					if (!this.listing.listingAttr.data[`${name}`]&&name!='inputValue_29'&&name!='inputValue_38'&&name!='inputValue_40'
						&&name!='checkboxValue_30'&&name!='checkboxValue_43'&&name!='checkboxValue_45') {
						this.countError++;
						console.log("name",name)
					}else{
						this.validateInputDynamic.push(name);
					}
				});
			}
			if((this.listing.mainCategory.idCategory!==35&&this.listing.mainCategory.idCategory!==36)&&(this.listing.subCategory&&this.listing.subCategory.id==37)){
				if(this.listing.listingAttr.data[`inputValue_29`]!='undefined'&&!this.listing.listingAttr.data[`inputValue_29`]&&(this.listing.listingAttr.data['checkboxValue_30']!='undefined'&&!this.listing.listingAttr.data['checkboxValue_30'])){
					this.countError++;
					const index = this.validateInputDynamic.indexOf('inputValue_29');
					if (index > -1) {
						this.validateInputDynamic.splice(index, 1);
					}
					console.log("if inputValue_29")
				}else{
					this.validateInputDynamic.push(`inputValue_29`);
				}
			}
			if((this.listing.mainCategory.idCategory!==35&&this.listing.mainCategory.idCategory!==36)&&(this.listing.subCategory&&this.listing.subCategory.id==41)){
				if (this.listing.listingAttr.data[`inputValue_38`]!='undefined'&& !this.listing.listingAttr.data[`inputValue_38`]&&this.listing.listingAttr.data['checkboxValue_43']!='undefined'&&!this.listing.listingAttr.data['checkboxValue_43']) {
					const index = this.validateInputDynamic.indexOf('inputValue_38');
					if (index > -1) {
						this.validateInputDynamic.splice(index, 1);
					}
					this.countError++;
					console.log("if inputValue_38")
				}else{
					this.validateInputDynamic.push('inputValue_38');
				}
			
				if (this.listing.listingAttr.data[`inputValue_40`]!='undefined'&& !this.listing.listingAttr.data[`inputValue_40`]&&this.listing.listingAttr.data['checkboxValue_45']!='undefined'&&!this.listing.listingAttr.data['checkboxValue_45']) {
					const index = this.validateInputDynamic.indexOf('inputValue_40');
					if (index > -1) {
						this.validateInputDynamic.splice(index, 1);
					}
					this.countError++;
					console.log("if inputValue_40")
				}else{
					this.validateInputDynamic.push('inputValue_40');
				}
			}
			if ( !this.listing.price) {
				this.validateErrors[`price`] = true;
				this.countError++;
				console.log("price")
			}
			if((!this.markerLat && !this.markerLng)|| !this.loclationAddress){
				this.validateErrors[`address`] = true;
				this.countError++;
			}
			if (!this.listing.listingImage.length) {
				this.validateErrors[`imageError`] = true;
				this.countError++;
				this.makeToastError(this.$t('Please upload a picture'));
				return;
			}
			console.info('this.validateInputDynamic', this.validateInputDynamic);
			console.info('this.validateErrors', this.validateErrors);
			console.info('this.countError', this.countError);
			// this.openPakcageDialog();
			// this.getListingForSubmit();
		},
		makeToastError(text) {
			console.log("teexty",text)
			this.$bvToast.toast(text, {
				title: `Error!`,
				variant: 'danger',
				solid: true
			});
		},
		numberAmountMask() {
			return createNumberMask({
				prefix: '',
				suffix: '',
				allowDecimal: true,
				includeThousandsSeparator: true,
				allowNegative: false
			});
		},
		getListingEdit() {
			this.GET_LISTING_PREVIEW(this.$route.params.id).catch(error => {
				if (error.status == 404) {
					this.$router.push(this.$i18nRoute({ name: '' }));
				}
			});
		},
		previousEditListing() {
			if (this.$route.name === 'AddListing') {
				this.$router.push(
					this.$i18nRoute(
						{ name: 'edit-listing' },
						this.listListingJustCreated ? this.listListingJustCreated.id : null
					)
				);
			}
			this.$bvModal.hide('listing-preview-dialog-first');
			// this.$forceUpdate();
		},
		previewAddListing() {
			if (this.listListingJustCreated) {
				const id = this.listListingJustCreated.id;
				this.GET_LISTING_PREVIEW(id).then(res => {
					console.log(res);
					this.$bvModal.show('preview-model');
				});
			}
		},

		tagValidator(tag) {
			// Individual tag validator function
			return tag === tag && tag.length > 1 && tag.length < 20;
		},
		changeRadioValue(ev, name) {
			console.log("change radio value")
			this.listing.listingAttr.data[name] = ev;
			this.$forceUpdate();
		},
		clearAutoComplete(){
			this.loclationAddress = null;
		},
		processLocationChanged(ev) {
			this.loclationAddress = ev.formatted_address;
			this.lat = ev.geometry.location.lat();
			this.lng = ev.geometry.location.lng();
			this.markerLat = ev.geometry.location.lat();
			this.markerLng = ev.geometry.location.lng();
			this.decodeLatLong();
		},
		ok(){
			this.decodeLatLong();
			this.cancel();
		},
		cancel(){
			this.mapAreaSelected=false;
			this.$bvModal.hide('showgooglemap-model');
		},
		decodeLatLong() {
			this.$gmapApiPromiseLazy().then(() => {
				// eslint-disable-next-line no-undef
				const geocoder = new google.maps.Geocoder()

				geocoder.geocode({ location: { lat: this.markerLat, lng: this.markerLng } }, (results, status) => {
					console.log("result",results)
					this.loclationAddress=results[0].formatted_address;
					results[0].address_components.forEach(elm=>{
						if(elm.types[0]=='postal_code'){
							this.postal_code=elm.long_name;
						}
						if(elm.types[0]=="country"){
							this.country=elm.long_name;
						}
					})
				
				})
			})
		},
		initMap() {
			setTimeout(() => {
				this.$refs.mapRef.$mapPromise.then((map) => {
					this.map = map;
					map.panTo({ lat: this.lat, lng: this.lng });
				});
			}, 200);
		},
		getPosition(ev) {
			console.log(ev)
			this.markerLat = ev.latLng ? ev.latLng.lat() : ev.lat();
			this.markerLng = ev.latLng ? ev.latLng.lng() : ev.lng();
			this.decodeLatLong();
			
		},
		putMarker(ev) {
			console.log(ev)
			this.markerLat = ev.latLng ? ev.latLng.lat() : ev.lat();
			this.markerLng = ev.latLng ? ev.latLng.lng() : ev.lng();
			this.decodeLatLong();
			
		},
		getMyLocation() {
			let _this = this;
			this.initMap();
			if (navigator.geolocation && this.map) {
				navigator.geolocation.getCurrentPosition(({ coords }) => {
				
				_this.lat = coords.latitude;
				_this.lng = coords.longitude;
				_this.putMarker( new window.google.maps.LatLng(coords.latitude, coords.longitude));
				});
			} else {
				alert("Geolocation is not supported by this browser.");
			}
		},
		closeTranslationDialog(){
			this.$bvModal.hide('trasnlatation-error');
		},
		changeLanguageTab(lang){
			lang==Trans.currentLanguage?false:this.checkForm();
			if(lang==Trans.currentLanguage?true:!this.countError){
				if(lang!=this.selectedLangugae){
					if(Object.keys(this.listingInOther).length){
						if(this.listingInOther[lang]!=undefined){
							this.listing.title=this.listingInOther[lang].title;
							this.listing.description=this.listingInOther[lang].description;
							this.listing.keywords=this.listingInOther[lang].keywords;
							this.$forceUpdate();
						}else{
							this.listingInOther[Trans.currentLanguage]={
								title:_.clone(this.listing.title),
								description:_.clone(this.listing.description),
								keywords:_.clone(this.listing.keywords)
							}
							this.listing.title=null;
							this.listing.description=null;
							this.listing.keyword=[];
							this.$forceUpdate();
						}
					}else{
						this.listingInOther[Trans.currentLanguage]={
							title:_.clone(this.listing.title),
							description:_.clone(this.listing.description),
							keywords:_.clone(this.listing.keywords)
						}
						this.listing.title=null;
						this.listing.description=null;
						this.listing.keyword=[];
					}
					this.selectedLangugae=lang;
					this.$forceUpdate();
				}
			}else{
				this.$bvModal.show('trasnlatation-error');
			}
		},
		trasnlateToOtherLanguage(){
				this.$root.loading=true;
				this.listing.title=this.listingInOther[Trans.currentLanguage].title;
				this.listing.description=this.listingInOther[Trans.currentLanguage].description;
				this.listing.keywords=this.listingInOther[Trans.currentLanguage].keywords;
				this.$forceUpdate();
				let obj={
					title:this.listing.title,
					description:this.listing.description,
					keywords:this.listing.keywords.length?this.listing.keywords:[],
					to:this.selectedLangugae
				}
				this.TRANSLATE_LISTING(obj).then(({data})=>{
					console.log('data',data);
					this.listing.title=data.data.translationResult.title.text;
					this.listing.description=data.data.translationResult.description.text;
					this.listing.keywords=data.data.translationResult.keywords?data.data.translationResult.keywords.text:[];
					this.$root.loading=false;
					this.listingInOther[this.selectedLangugae].title=this.listing.title;
					this.listingInOther[this.selectedLangugae].description=this.listing.description;
					this.listingInOther[this.selectedLangugae].keywords=this.listing.keywords;
				}).catch((err)=>{
					this.$root.loading=false;
				})
		},
		shadeColor(color, percent) {

			var R = parseInt(color.substring(1, 3), 16);
			var G = parseInt(color.substring(3, 5), 16);
			var B = parseInt(color.substring(5, 7), 16);

			R = parseInt(R * (100 - percent) / 100);
			G = parseInt(G * (100 - percent) / 100);
			B = parseInt(B * (100 - percent) / 100);

			R = (R < 255) ? R : 255;
			G = (G < 255) ? G : 255;
			B = (B < 255) ? B : 255;

			var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
			var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
			var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

			return "#" + RR + GG + BB;
		}
	}
};
</script>

<style lang="scss">
@import 'editListingDesktop.scss';
#image-ads-model{
	.modal-content{
		background:transparent;
		border: none;
	}
}
</style>
